export default __webpack_public_path__ + "c11f1255f1c16770fdd0003a6982945a.ttf";